import { applySpec } from 'ramda';
import { connect } from 'react-redux';
import { getUserId } from 'store/selectors/user';
import Alerts from 'components/Alerts';

const mapStateToProps = applySpec({
  userId: getUserId,
});

export default connect(mapStateToProps)(Alerts);
